<template>
  <div class="irregularly-repeat">
    <h3 class="title text-gray-700 font-medium">
      Detail for each added schedule
    </h3>
    <div
      class="irregular-day-option flex"
      v-for="(repeat, index) in repeatOn"
      :key="index"
    >
      <div class="settings flex">
        <div class="flex items-center my-4 flex-w-auto">
          <md-datepicker
            md-immediately
            readonly
            aria-placeholder="Irregular date"
            v-model="repeat.date"
            :md-model-type="String"
          >
            <label> Choose date </label>
          </md-datepicker>
        </div>

        <div class="ml-4">
          <day-selection
            :is-all-day="isAllDay"
            :repeat="repeat"
          ></day-selection>
        </div>
      </div>
      <div v-if="isAbleToDelete" class="actions">
        <md-button
          class="ml-2 md-simple md-just-icon md-icon-button md-danger"
          @click.native="() => deleteSetting(index)"
        >
          <md-icon :style="{ fontSize: '30px !important' }"
            >delete_forever</md-icon
          >
        </md-button>
      </div>
    </div>

    <md-button class="md-success" @click.native="addNewSetting">
      <i class="fas fa-plus text-sm"></i>
      Add
    </md-button>
  </div>
</template>

<script>
import DaySelection from "./DaySelection";

export default {
  components: { DaySelection },
  props: ["isAllDay", "repeatOn"],
  computed: {
    isAbleToDelete() {
      return this.repeatOn.length > 1;
    }
  },
  methods: {
    addNewSetting() {
      const newRepeatOn = [
        ...this.repeatOn,
        {
          toTime: "",
          fromTime: "",
          date: "",
          location: ""
        }
      ];
      this.$emit("update-repeat", newRepeatOn);
    },
    deleteSetting(index) {
      this.repeatOn.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.irregular-day-option {
  width: 100%;

  .settings {
    width: 90%;
  }

  .actions {
    width: 10%;
  }
}
</style>
